var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOmniChannel = function SvgOmniChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.39,
    y1: 159.94,
    x2: 138.28,
    y2: 21.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 7.78,
    y1: 138.32,
    x2: 108.68,
    y2: 0.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.6,
    y1: 165.21,
    x2: 145.49,
    y2: 27.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.68,
    y1: 147.74,
    x2: 121.58,
    y2: 9.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.43,
    y1: 133.69,
    x2: 102.33,
    y2: -4.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 14.65,
    y1: 143.34,
    x2: 115.54,
    y2: 5.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 84.43,
    y1: 194.29,
    x2: 185.32,
    y2: 56.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 73.49,
    y1: 186.3,
    x2: 174.38,
    y2: 48.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 62.79,
    y1: 178.49,
    x2: 163.68,
    y2: 40.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 102.09,
    y1: 207.19,
    x2: 202.99,
    y2: 69.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 88.88,
    y1: 197.54,
    x2: 189.77,
    y2: 59.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 67.31,
    y1: 181.79,
    x2: 168.2,
    y2: 43.63,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.33,33.33c1.84,0,3.33-1.49,3.33-3.33V10c0-1.83,1.5-3.33,3.33-3.33h80c1.83,0,3.33,1.5,3.33,3.33v40c0,1.83-1.5,3.33-3.33,3.33h-6.67c-1.84,0-3.33,1.49-3.33,3.33v10.79l-10.77-12.93c-.63-.77-1.57-1.2-2.56-1.2h-10c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h8.44l15.67,18.8c.65.78,1.59,1.2,2.56,1.2.38,0,.76-.07,1.13-.2,1.32-.48,2.2-1.73,2.2-3.13v-16.67h3.33c5.51,0,10-4.49,10-10V10C180,4.49,175.51,0,170,0h-80C84.49,0,80,4.49,80,10v20c0,1.84,1.49,3.33,3.33,3.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50,113.33h-6.67c-1.05,0-2.04.49-2.67,1.33l-14,18.67v-16.67c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.83,0-3.33-1.5-3.33-3.33v-60c0-1.83,1.5-3.33,3.33-3.33h106.67c1.83,0,3.33,1.5,3.33,3.33v26.67c0,1.84,1.49,3.33,3.33,3.33s3.33-1.49,3.33-3.33v-26.67c0-5.51-4.49-10-10-10H10c-5.51,0-10,4.49-10,10v60c0,5.51,4.49,10,10,10h10v23.33c0,1.43.92,2.71,2.28,3.17.35.11.7.17,1.05.17,1.03,0,2.03-.47,2.67-1.33l19-25.33h5c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160,30c0-1.84-1.49-3.33-3.33-3.33h-26.67c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h26.67c1.84,0,3.33-1.49,3.33-3.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.67,26.67c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h20c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.33,86.67c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h20c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-20Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.67,76.67c0-1.84-1.49-3.33-3.33-3.33H23.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h80c1.84,0,3.33-1.49,3.33-3.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190,86.67h-120c-5.51,0-10,4.49-10,10v66.67c0,5.51,4.49,10,10,10h85l19,25.33c.64.86,1.64,1.33,2.67,1.33.35,0,.71-.06,1.05-.17,1.36-.46,2.28-1.73,2.28-3.17v-23.33h10c5.51,0,10-4.49,10-10v-66.67c0-5.51-4.49-10-10-10ZM193.33,163.33c0,1.83-1.5,3.33-3.33,3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v16.67l-14-18.67c-.63-.84-1.62-1.33-2.67-1.33h-86.67c-1.83,0-3.33-1.5-3.33-3.33v-66.67c0-1.83,1.5-3.33,3.33-3.33h120c1.83,0,3.33,1.5,3.33,3.33v66.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M116.67,146.67h-33.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.33,140h20c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-20c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M176.67,120h-26.67c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h26.67c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150,133.33h-33.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.33,126.67h53.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-53.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z"
  })));
};
export default SvgOmniChannel;